import { Component, inject, Input } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfig } from '@app/core/app.config';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Entity } from '@app/core/model/entities/entity';
import { InvestmentInput } from '@app/core/model/entities/investment/investment';
import { GeneratesObject } from '@app/shared/interfaces/generates-object';
import { TranslateService } from '@ngx-translate/core';
import { AccessManager } from '@services/managers/access.manager';

@Component({
  selector: 'investment-create-modal',
  templateUrl: './investment-create-modal.component.html',
  styleUrl: '../../../../../../../shared/components/form-builder/sections/create-modal.component.scss',
  standalone: false
})
export class InvestmentCreateModalComponent implements GeneratesObject {

  @Input() private data: { entity: Entity, entityType: EntityTypeEnum } = inject(MAT_DIALOG_DATA);

  protected nameForm: FormControl<string>;
  protected missingRequiredFields: { code: string, label: string }[];

  protected readonly appConfig = inject(AppConfig);
  private readonly fb = inject(FormBuilder);
  private readonly accessManager = inject(AccessManager);
  private readonly translate = inject(TranslateService);

  constructor() {
    this.nameForm = this.fb.control(null, Validators.compose([
      Validators.required,
      Validators.maxLength(this.appConfig.FIELD_MAX_LENGTH)
    ]));
    this.missingRequiredFields = [
      {code: 'name', label: this.translate.instant('LABEL.NAME')},
      {code: 'type', label: this.translate.instant('LABEL.INVESTMENT_TYPE')},
      {code: 'entityId', label: this.translate.instant('LABEL.ENTITY_ID')},
    ].filter(({code}) => !this.accessManager.hasFieldWriteOnCreateAccess(code, EntityTypeEnum.INVESTMENT));
  }

  public getGeneratedObject(): InvestmentInput {
    return {
      name: this.nameForm.value,
      type: this.data.entityType,
      entityId: this.data.entity.id,
    };
  }
}
